/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface AccountAcceptInvitationResponse
 */
export interface AccountAcceptInvitationResponse {
    /**
     * 
     * @type {string}
     * @memberof AccountAcceptInvitationResponse
     */
    projectId: string;
}

export function AccountAcceptInvitationResponseFromJSON(json: any): AccountAcceptInvitationResponse {
    return {
        'projectId': json['projectId'],
    };
}

export function AccountAcceptInvitationResponseToJSON(value?: AccountAcceptInvitationResponse): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'projectId': value.projectId,
    };
}


